(function () {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionAssetsPickerDialogController', SessionAssetsPickerDialogController);

    var LINKED_ASSETS_SELECTION_LIMIT = 20;

    function ibmAssetStatusLabel(asset) {
        var s = asset ? asset.status : null;
        if (typeof s === 'string') {
            return s;
        }
        if (s && typeof s === 'object' && typeof s.name === 'string') {
            return s.name;
        }
        var raw = asset && typeof asset.asset_status === 'string' ? asset.asset_status : '';
        return raw;
    }

    function ibmAssetStatusDisplay(asset) {
        var label = ibmAssetStatusLabel(asset);
        return typeof label === 'string' ? label.trim() : '';
    }

    function ibmLocationInfoRecord(row) {
        var info = row && row.info;
        return info && typeof info === 'object' ? info : null;
    }

    function ibmLocationNestedRecord(row) {
        if (!row || typeof row !== 'object') {
            return null;
        }
        var candidates = [row.location, row.properties, row.details, row.attributes, row.site];
        for (var i = 0; i < candidates.length; i++) {
            if (candidates[i] && typeof candidates[i] === 'object') {
                return candidates[i];
            }
        }
        return null;
    }

    function ibmLocationDisplayName(row) {
        if (row == null) {
            return '';
        }
        if (typeof row === 'string') {
            return row.trim();
        }
        if (typeof row !== 'object') {
            return '';
        }
        var info = ibmLocationInfoRecord(row);
        var nested = ibmLocationNestedRecord(row);
        var candidates = [
            row.name,
            row.label,
            row.location_name,
            row.displayName,
            row.display_name,
            row.title,
            info && info.name,
            info && info.label,
            info && info.location_name,
            info && info.title,
            nested && nested.name,
            nested && nested.label,
            nested && nested.location_name
        ];
        for (var i = 0; i < candidates.length; i++) {
            if (typeof candidates[i] === 'string' && candidates[i].trim()) {
                return candidates[i].trim();
            }
        }
        return '';
    }

    function ibmLocationId(row) {
        if (row == null) {
            return '';
        }
        if (typeof row === 'string') {
            return row.trim();
        }
        if (typeof row !== 'object') {
            return '';
        }
        var info = ibmLocationInfoRecord(row);
        var nested = ibmLocationNestedRecord(row);
        var candidates = [
            row.id,
            row.guid,
            row.code,
            row.location_id,
            info && info.id,
            info && info.guid,
            info && info.code,
            nested && nested.id,
            nested && nested.guid,
            nested && nested.code
        ];
        for (var i = 0; i < candidates.length; i++) {
            if (candidates[i] != null && String(candidates[i]).trim()) {
                return String(candidates[i]).trim();
            }
        }
        return ibmLocationDisplayName(row);
    }

    function ibmAssetLocationIds(asset) {
        var locations = asset && asset.locations;
        if (!angular.isArray(locations)) {
            return [];
        }
        var ids = [];
        angular.forEach(locations, function (link) {
            if (!link || link.id == null) {
                return;
            }
            var id = String(link.id).trim();
            if (id) {
                ids.push(id);
            }
        });
        return ids;
    }

    function ibmAssetLocationLabel(asset, locationNameById) {
        if (!asset) {
            return '';
        }
        var loc = asset.location;
        if (typeof loc === 'string') {
            return loc;
        }
        var fromLoc = ibmLocationDisplayName(loc);
        if (fromLoc) {
            return fromLoc;
        }
        if (typeof asset.location_name === 'string') {
            return asset.location_name;
        }
        var linkedIds = ibmAssetLocationIds(asset);
        if (linkedIds.length && locationNameById) {
            var names = [];
            angular.forEach(linkedIds, function (id) {
                var name = locationNameById[id];
                if (typeof name === 'string' && name.trim()) {
                    names.push(name.trim());
                }
            });
            if (names.length) {
                return names.join(', ');
            }
        }
        var topics = asset.topics;
        if (angular.isArray(topics) && topics.length && topics[0] && typeof topics[0].name === 'string') {
            return topics[0].name;
        }
        return '';
    }

    function assetLocationId(asset) {
        var linkedIds = ibmAssetLocationIds(asset);
        if (linkedIds.length) {
            return linkedIds[0];
        }
        var loc = asset && asset.location;
        if (loc != null) {
            var fromLoc = ibmLocationId(loc);
            if (fromLoc) {
                return fromLoc;
            }
        }
        var id = asset && asset.location_id;
        return id == null ? '' : String(id);
    }

    function ibmAssetModel(asset) {
        if (!asset) {
            return '—';
        }
        var m = asset.model || asset.model_no || asset.model_number || asset.modelNumber;
        var r = typeof m === 'string' ? m : m == null ? '' : String(m);
        return r || '—';
    }

    function ibmAssetSerial(asset) {
        if (!asset) {
            return '—';
        }
        var s = asset.serial_number || asset.serial_no || asset.serialNumber;
        var r = typeof s === 'string' ? s : s == null ? '' : String(s);
        return r || '—';
    }

    function ibmAssetStatusBadgeClass(asset) {
        var label = ibmAssetStatusLabel(asset);
        var normalized =
            typeof label === 'string' ? label.toLowerCase().replace(/\s+/g, '') : '';
        switch (normalized) {
            case 'paused':
                return 'status-paused';
            case 'open':
                return 'status-open';
            case 'completed':
                return 'status-completed';
            case 'active':
                return 'status-active';
            case 'maintenance':
                return 'status-maintenance';
            default:
                return 'status-muted';
        }
    }

    function requireId(asset) {
        if (!asset || asset.id == null) {
            return null;
        }
        var idStr = String(asset.id).trim();
        return idStr === '' ? null : idStr;
    }

    function flattenTopics(nodes) {
        var flattened = [];

        function visit(children) {
            if (!children || !children.length) {
                return;
            }
            angular.forEach(children, function (n) {
                if (n && n.id) {
                    flattened.push({ id: String(n.id), name: n.name || '' });
                }
                if (n && n.sub_topics && n.sub_topics.length) {
                    visit(n.sub_topics);
                }
            });
        }

        visit(nodes);
        return flattened;
    }

    function effectiveTopicId(selection) {
        if (selection == null || selection === '__ALL_TOPICS__') {
            return null;
        }
        return selection;
    }

    function extractLocationRows(body) {
        if (angular.isArray(body)) {
            return body;
        }
        if (!body || typeof body !== 'object') {
            return [];
        }
        return (
            body.locations ||
            body.data ||
            body.content ||
            body.items ||
            body.results ||
            []
        );
    }

    function toLocationOption(row) {
        var label = ibmLocationDisplayName(row);
        var value = ibmLocationId(row);
        if (!label && !value) {
            return null;
        }
        return {
            value: value || label,
            label: label || value
        };
    }

    function parseAssetsList(responseData) {
        if (angular.isArray(responseData)) {
            return responseData;
        }
        if (!responseData || typeof responseData !== 'object') {
            return [];
        }
        if (angular.isArray(responseData.assets)) {
            return responseData.assets;
        }
        if (responseData.body && angular.isArray(responseData.body.assets)) {
            return responseData.body.assets;
        }
        return [];
    }

    function parseFilteredCount(responseData, assetsLength) {
        if (!responseData || typeof responseData !== 'object') {
            return assetsLength;
        }
        if (responseData.filtered_count != null) {
            return Number(responseData.filtered_count);
        }
        if (responseData.body && responseData.body.filtered_count != null) {
            return Number(responseData.body.filtered_count);
        }
        return assetsLength;
    }

    function resolveWorkspacePrimaryColor(triSettings, triTheming) {
        var skin = triSettings.getSkinModel() || {};
        if (skin.primary_color_hex) {
            return skin.primary_color_hex;
        }
        var paletteColor = triTheming.getPaletteColor(skin.primary_color || 'teal', '500');
        return (paletteColor && (paletteColor.hex || paletteColor.value)) || '#009688';
    }

    /* @ngInject */
    function SessionAssetsPickerDialogController(
        $mdDialog,
        $timeout,
        $filter,
        IBM,
        triSettings,
        triTheming,
        ToastService,
        initialSelection
    ) {
        var vm = this;

        vm.primaryColor = resolveWorkspacePrimaryColor(triSettings, triTheming);
        vm.primaryFillStyle = {
            'background-color': vm.primaryColor,
            color: '#ffffff'
        };

        vm.linkedAssetsSelectionLimit = LINKED_ASSETS_SELECTION_LIMIT;

        var seenStatusDict = {};
        var seenLocationOptions = {};
        var locationNameById = {};
        var pendingLocationResolveIds = {};

        vm.pageSize = 10;
        vm.pageIndex = 0;
        vm.totalCount = 0;
        vm.rows = [];
        vm.loading = false;

        vm.searchInput = '';
        vm.searchText = '';
        vm.searchDebounceTimer = null;

        vm.viewSelectedOnly = false;

        vm.selectedStatus = '';
        vm.selectedLocation = '';
        vm.statusChoices = [];
        vm.locationOptions = [];

        vm.allTopicOptions = [];
        vm.selectedTopicId = '__ALL_TOPICS__';

        vm.selectedOrder = [];
        vm.selectedById = {};
        vm.initialSelectionCount = 0;

        function exceedsSelectionLimit() {
            return vm.selectionCount() > LINKED_ASSETS_SELECTION_LIMIT;
        }

        function showSelectionLimitAlert() {
            var title = $filter('translate')('atheer.session.detail.assetsSelectionLimitTitle');
            var message = $filter('translate')('atheer.session.detail.assetsSelectionLimitAlert', {
                limit: LINKED_ASSETS_SELECTION_LIMIT
            });
            ToastService.displayToastWithRenderHtml(
                '<strong>' + title + '</strong><br>' + message,
                4000
            );
        }

        function rebuildStatusChoices() {
            vm.statusChoices = Object.keys(seenStatusDict).sort(function (x, y) {
                return x.localeCompare(y);
            });
        }

        function absorbFilterOptionsFromAssets(rawAssets) {
            angular.forEach(rawAssets, function (a) {
                var st = ibmAssetStatusLabel(a);
                if (st) {
                    seenStatusDict[st] = true;
                }
                var locOption = toLocationOption(a && a.location);
                if (locOption && !seenLocationOptions[locOption.value]) {
                    seenLocationOptions[locOption.value] = locOption;
                }
                angular.forEach(ibmAssetLocationIds(a), function (id) {
                    var cached = locationNameById[id];
                    if (cached && !seenLocationOptions[id]) {
                        seenLocationOptions[id] = { value: id, label: cached };
                    }
                });
            });
            rebuildStatusChoices();
            mergeLocationOptions([]);
        }

        function registerLocationOptions(fromApi) {
            angular.forEach(fromApi, function (opt) {
                if (!opt || !opt.value) {
                    return;
                }
                locationNameById[opt.value] = opt.label || opt.value;
                if (!seenLocationOptions[opt.value]) {
                    seenLocationOptions[opt.value] = opt;
                }
            });
            mergeLocationOptions(fromApi);
        }

        function resolveLocationNamesForAssets(assets) {
            var missingIds = [];
            angular.forEach(assets, function (asset) {
                angular.forEach(ibmAssetLocationIds(asset), function (id) {
                    if (!locationNameById[id] && !pendingLocationResolveIds[id]) {
                        missingIds.push(id);
                        pendingLocationResolveIds[id] = true;
                    }
                });
            });
            if (!missingIds.length) {
                return;
            }
            IBM.getLocations({ ids: missingIds, limit: missingIds.length })
                .then(function (result) {
                    var rows = extractLocationRows(result.data);
                    var fromApi = rows
                        .map(function (row) {
                            return toLocationOption(row);
                        })
                        .filter(Boolean);
                    registerLocationOptions(fromApi);
                })
                .finally(function () {
                    angular.forEach(missingIds, function (id) {
                        delete pendingLocationResolveIds[id];
                    });
                });
        }

        function mergeLocationOptions(fromApi) {
            var merged = {};
            angular.forEach(fromApi, function (opt) {
                if (opt && opt.value) {
                    merged[opt.value] = opt;
                }
            });
            angular.forEach(seenLocationOptions, function (opt, key) {
                if (!merged[key]) {
                    merged[key] = opt;
                }
            });
            vm.locationOptions = Object.keys(merged)
                .map(function (key) {
                    return merged[key];
                })
                .sort(function (a, b) {
                    return a.label.localeCompare(b.label);
                });
        }

        function snapshotSelectionFromRows(rowsArr) {
            angular.forEach(rowsArr, function (row) {
                var idStr = requireId(row);
                if (!idStr || !vm.selectedById[idStr]) {
                    return;
                }
                vm.selectedById[idStr] = angular.extend({}, row);
            });
        }

        angular.forEach(initialSelection || [], function (a) {
            var idStr = requireId(a);
            if (!idStr || vm.selectedById[idStr]) {
                return;
            }
            vm.selectedById[idStr] = angular.extend({}, a);
            vm.selectedOrder.push(idStr);
        });
        vm.initialSelectionCount = vm.selectedOrder.length;
        resolveLocationNamesForAssets(initialSelection || []);
        absorbFilterOptionsFromAssets(initialSelection || []);

        vm.selectionCount = function () {
            return vm.selectedOrder.length;
        };

        vm.categoryTitle = function () {
            if (!vm.selectedTopicId || vm.selectedTopicId === '__ALL_TOPICS__') {
                return null;
            }
            var match = null;
            angular.forEach(vm.allTopicOptions, function (opt) {
                if (!match && String(opt.id) === String(vm.selectedTopicId)) {
                    match = opt;
                }
            });
            return match ? match.name : null;
        };

        vm.selectedLocationLabel = function () {
            if (!vm.selectedLocation) {
                return '';
            }
            var label = vm.selectedLocation;
            angular.forEach(vm.locationOptions, function (opt) {
                if (String(opt.value) === String(vm.selectedLocation)) {
                    label = opt.label;
                }
            });
            return label;
        };

        vm.close = function () {
            $mdDialog.cancel();
        };

        vm.canDone = function () {
            return vm.selectionCount() > 0 || vm.initialSelectionCount > 0;
        };

        vm.done = function () {
            if (!vm.canDone()) {
                return;
            }
            if (exceedsSelectionLimit()) {
                showSelectionLimitAlert();
                return;
            }
            var assets = [];
            angular.forEach(vm.selectedOrder, function (idStr) {
                var row = vm.selectedById[idStr];
                if (row) {
                    assets.push(angular.extend({}, row));
                }
            });
            $mdDialog.hide({ assets: assets });
        };

        vm.deselectAll = function () {
            vm.selectedById = {};
            vm.selectedOrder = [];
            vm.pageIndex = 0;
            vm.fetchPage();
        };

        vm.toggleViewSelectedOnly = function () {
            if (vm.viewSelectedOnly && exceedsSelectionLimit()) {
                vm.viewSelectedOnly = false;
                showSelectionLimitAlert();
                return;
            }
            vm.pageIndex = 0;
            vm.fetchPage();
        };

        vm.onFilterChanged = function () {
            vm.pageIndex = 0;
            vm.fetchPage();
        };

        vm.onTopicChanged = function () {
            vm.pageIndex = 0;
            vm.fetchPage();
        };

        vm.selectTopic = function (topicId) {
            vm.selectedTopicId = topicId;
            vm.onTopicChanged();
        };

        vm.onSearchInput = function () {
            if (vm.searchDebounceTimer) {
                $timeout.cancel(vm.searchDebounceTimer);
            }
            vm.searchDebounceTimer = $timeout(function () {
                vm.searchText =
                    vm.searchInput == null ? '' : String(vm.searchInput).trim();
                vm.pageIndex = 0;
                vm.fetchPage();
            }, 400);
        };

        vm.isRowSelected = function (row) {
            var idStr = requireId(row);
            return !!(idStr && vm.selectedById[idStr]);
        };

        vm.onRowClick = function (row) {
            if (!requireId(row)) {
                return;
            }
            vm.toggleRow(row, !vm.isRowSelected(row));
        };

        vm.rowCheckboxClicked = function (row, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            vm.toggleRow(row, !vm.isRowSelected(row));
        };

        vm.masterCheckboxClicked = function ($event) {
            if ($event) {
                $event.stopPropagation();
            }
            vm.toggleMaster(!vm.allPageRowsSelected());
        };

        vm.toggleRow = function (row, checked) {
            var idStr = requireId(row);
            if (!idStr) {
                return;
            }
            if (checked) {
                if (!vm.selectedById[idStr]) {
                    vm.selectedById[idStr] = angular.extend({}, row);
                    vm.selectedOrder.push(idStr);
                }
            } else {
                delete vm.selectedById[idStr];
                var ix = vm.selectedOrder.indexOf(idStr);
                if (ix !== -1) {
                    vm.selectedOrder.splice(ix, 1);
                }
            }
            vm.updateMasterCheckboxState();
        };

        vm.allPageRowsSelected = function () {
            if (!vm.rows.length) {
                return false;
            }
            var all = true;
            angular.forEach(vm.rows, function (row) {
                if (!requireId(row) || !vm.isRowSelected(row)) {
                    all = false;
                }
            });
            return all;
        };

        vm.isIndeterminateMaster = function () {
            if (!vm.rows.length) {
                return false;
            }
            var count = 0;
            angular.forEach(vm.rows, function (row) {
                if (requireId(row) && vm.isRowSelected(row)) {
                    count++;
                }
            });
            return count > 0 && count < vm.rows.length;
        };

        vm.updateMasterCheckboxState = function () {
            $timeout(function () {
                var el = document.getElementById('fp-sam-master-checkbox');
                if (el) {
                    el.indeterminate = vm.isIndeterminateMaster();
                }
            });
        };

        vm.toggleMaster = function (checked) {
            angular.forEach(vm.rows, function (row) {
                if (!requireId(row)) {
                    return;
                }
                vm.toggleRow(row, checked);
            });
        };

        vm.rowStatusDisplay = function (row) {
            return ibmAssetStatusDisplay(row);
        };

        vm.rowLocation = function (row) {
            var l = ibmAssetLocationLabel(row, locationNameById);
            return l || '—';
        };

        vm.rowModel = function (row) {
            return ibmAssetModel(row);
        };

        vm.rowSerial = function (row) {
            return ibmAssetSerial(row);
        };

        vm.statusBadgeClass = function (row) {
            return ibmAssetStatusBadgeClass(row);
        };

        vm.rangeLabel = function () {
            if (!vm.totalCount) {
                return '';
            }
            var start = vm.pageIndex * vm.pageSize + 1;
            var end = Math.min((vm.pageIndex + 1) * vm.pageSize, vm.totalCount);
            return start + ' – ' + end + ' of ' + vm.totalCount;
        };

        vm.canPrev = function () {
            return vm.pageIndex > 0;
        };

        vm.canNext = function () {
            return (vm.pageIndex + 1) * vm.pageSize < vm.totalCount;
        };

        vm.canFirst = function () {
            return vm.canPrev();
        };

        vm.canLast = function () {
            return vm.canNext();
        };

        vm.firstPage = function () {
            if (!vm.canFirst()) {
                return;
            }
            vm.pageIndex = 0;
            vm.fetchPage();
        };

        vm.prevPage = function () {
            if (!vm.canPrev()) {
                return;
            }
            vm.pageIndex--;
            vm.fetchPage();
        };

        vm.nextPage = function () {
            if (!vm.canNext()) {
                return;
            }
            vm.pageIndex++;
            vm.fetchPage();
        };

        vm.lastPage = function () {
            if (!vm.canLast()) {
                return;
            }
            vm.pageIndex = Math.max(0, Math.ceil(vm.totalCount / vm.pageSize) - 1);
            vm.fetchPage();
        };

        vm.loadTopicOptions = function () {
            IBM.getTopics()
                .then(function (result) {
                    var tree = angular.isArray(result.data) ? result.data : [];
                    var flattened = flattenTopics(tree);
                    vm.allTopicOptions = flattened;
                })
                .catch(function () {
                    vm.allTopicOptions = [];
                });
        };

        vm.loadLocationOptions = function () {
            IBM.getLocations({ limit: 100 })
                .then(function (result) {
                    var rows = extractLocationRows(result.data);
                    var fromApi = rows
                        .map(function (row) {
                            return toLocationOption(row);
                        })
                        .filter(Boolean);
                    registerLocationOptions(fromApi);
                })
                .catch(function () {
                    mergeLocationOptions([]);
                });
        };

        vm.fetchPage = function () {
            if (vm.viewSelectedOnly) {
                vm.totalCount = vm.selectedOrder.length;
                var start = vm.pageIndex * vm.pageSize;
                vm.rows = vm.selectedOrder
                    .slice(start, start + vm.pageSize)
                    .map(function (idStr) {
                        return vm.selectedById[idStr];
                    })
                    .filter(Boolean);
                resolveLocationNamesForAssets(vm.rows);
                vm.updateMasterCheckboxState();
                return;
            }

            vm.loading = true;
            var params = {
                limit: vm.pageSize,
                skip: vm.pageIndex * vm.pageSize
            };

            if (vm.searchText) {
                params.search = vm.searchText;
            }

            var topicEffective = effectiveTopicId(vm.selectedTopicId);
            if (topicEffective != null) {
                params.topic = topicEffective;
                params.topics = topicEffective;
            }
            if (vm.selectedStatus) {
                params.status = vm.selectedStatus;
            }
            if (vm.selectedLocation) {
                params.location = vm.selectedLocation;
            }

            IBM.getAssets(params)
                .then(function (result) {
                    var body = result.data || {};
                    var assetsRaw = parseAssetsList(body);

                    vm.totalCount = parseFilteredCount(body, assetsRaw.length);

                    absorbFilterOptionsFromAssets(assetsRaw);

                    vm.rows = assetsRaw;
                    resolveLocationNamesForAssets(assetsRaw);
                    snapshotSelectionFromRows(vm.rows);
                    vm.updateMasterCheckboxState();
                })
                .catch(function (error) {
                    vm.rows = [];
                    vm.totalCount = 0;
                    console.error('Error loading IBM assets:', error);
                })
                .finally(function () {
                    vm.loading = false;
                });
        };

        vm.loadTopicOptions();
        vm.loadLocationOptions();
        vm.fetchPage();
    }
})();
